export const getFirstRowOfTablePageId = (numberOfRowsPageLimit,pageId)=>((numberOfRowsPageLimit*pageId)-numberOfRowsPageLimit)